import { LogManager } from '../../../common/port/log/log.manager.port';
import { SelfSentimentReportMapper } from '../../../infrastructure/mappers/sentiment/self-sentiment-report.mapper';
import { GetSelfSentimentReportRequestDto } from '../../dtos/sentiment/get-self-sentiment-report.request.dto';
import { GetSelfSentimentReportResponseDto } from '../../dtos/sentiment/get-self-sentiment-report.response.dto';
import { GetSelfSentimentReportQuery } from '../../queries/sentiment/get-self-sentiment-report.query';

export class GetSelfSentimentReportController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetSelfSentimentReportQuery,
    protected readonly mapper: SelfSentimentReportMapper
  ) {}

  async get(
    props: GetSelfSentimentReportRequestDto
  ): Promise<GetSelfSentimentReportResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result != undefined ? this.mapper.toResponse(result) : null;
    } catch (error) {
      throw new Error(
        `GetSelfSentimentReportController.get encountered an error ${error}`
      );
    }
  }
}
